import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-stone-950 text-stone-50 py-20 md:py-32 px-4 relative overflow-hidden" data-id="element-57">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-amber-900/10 blur-[120px] pointer-events-none" data-id="element-58" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-59">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-60">
          <FadeIn data-id="element-61">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-400 text-sm font-semibold mb-6" data-id="element-62">
              <span data-id="element-63">🔥</span> Más de 2,300 hombres ya recuperaron su movilidad
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-6 text-stone-50 tracking-tight" data-id="element-64">
              Dile adiós a la rigidez:{' '}
              <span className="text-amber-500" data-id="element-65">
                El Método de 10 Minutos para Despertar Sin Dolor Articular
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-stone-300 mb-8 leading-relaxed" data-id="element-66">
              Recupera la movilidad de tus 30s y levántate de la cama con
              agilidad, sin depender de pastillas ni sufrir "el primer paso" del
              día.
            </p>

            <ul className="space-y-3 mb-10 text-lg text-stone-300 font-medium" data-id="element-67">
              <li className="flex items-center gap-3" data-id="element-68">
                <CheckCircle2 className="w-6 h-6 text-amber-500 flex-shrink-0" data-id="element-69" />
                Sin pastillas
              </li>
              <li className="flex items-center gap-3" data-id="element-70">
                <CheckCircle2 className="w-6 h-6 text-amber-500 flex-shrink-0" data-id="element-71" />
                Sin gimnasio
              </li>
              <li className="flex items-center gap-3" data-id="element-72">
                <CheckCircle2 className="w-6 h-6 text-amber-500 flex-shrink-0" data-id="element-73" />
                Desde tu cama
              </li>
            </ul>

            <Button scrollTo="pricing" href="https://guiasparavivir.com/cart/52440554701089:1" data-id="element-74">
              ¡Sí! Quiero Despertar Sin Dolor
            </Button>

            <div className="mt-4 flex items-center justify-center md:justify-start gap-2 text-sm text-stone-400 font-medium" data-id="element-75">
              <ShieldCheck className="w-4 h-4 text-amber-500" data-id="element-76" />
              <span data-id="element-77">Acceso inmediato · Pago único · Sin suscripciones</span>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} className="relative" data-id="element-78">
            <div className="absolute inset-0 bg-gradient-to-tr from-amber-600/20 to-transparent rounded-2xl transform rotate-3 scale-105" data-id="element-79" />
            <img src="https://cdn.magicpatterns.com/uploads/ogM2PAgokvDNRtwF3vk6Tf/IMAGEN.png" alt="Despertar Sin Dolor en Tablet" className="relative z-10 w-full rounded-2xl shadow-2xl border border-stone-800" data-id="element-80" />
          </FadeIn>
        </div>
      </div>
    </section>;
}